{
  "it": {
    "task": {
      "actions": {
        "create": "Attività",
        "create_and_send": "Crea e invia",
        "delete": "Elimina attività",
        "keep_as_draft": "Mantieni come bozza",
        "open_in_project": "Apri l'attività nel progetto",
        "remove_from_unit": "Rimuovi l'attività da questa unità",
        "save_as_draft": "Salva come bozza",
        "update": "Modifica attività"
      },
      "attributes": {
        "assignments_count": "Assegnazioni",
        "category": "Modo di completamento",
        "created_at": "Creato",
        "description": "Descrizione",
        "phase": "Fase",
        "title": "Titolo"
      },
      "categories": {
        "confirmation": "Conferma",
        "upload": "Caricamento documento"
      },
      "categories_info": {
        "confirmation": "L'assegnatario la spunta quando è fatta.",
        "upload": "L'assegnatario deve caricare un file per completarla."
      },
      "confirm": {
        "delete_accept": "Elimina ovunque",
        "delete_body": "Questo elimina {count} attività su {units}, anche se è già completata. | Questo elimina tutte le {count} attività su {units}, comprese quelle già completate.",
        "delete_body_empty": "Questo elimina l'attività.",
        "delete_body_project": "Questo elimina l'attività e il suo responsabile. | Questo elimina l'attività e tutti i suoi {count} responsabili.",
        "delete_cancel": "Mantieni l'attività",
        "delete_header": "Eliminare «{title}»?",
        "delete_silent": "Nessuno riceve una notifica, e le notifiche già inviate non vengono ritirate.",
        "publish_body": "Creiamo {tasks} su {units} e le inviamo ai loro responsabili. Ogni attività resta Aperta finché non viene completata.",
        "publish_body_project": "Creiamo {tasks} in questo progetto e le inviamo ai loro responsabili. Ogni attività resta Aperta finché non viene completata.",
        "publish_header": "Creare e inviare questa attività?",
        "publish_info": "I responsabili ricevono subito un'email. Salvala come bozza se non sei ancora pronto a inviarla.",
        "remove_from_unit_accept": "Rimuovi dall'unità",
        "remove_from_unit_body": "Questo rimuove tutti i responsabili di questa attività in questa unità. L'attività e le sue altre unità restano invariate.",
        "remove_from_unit_customers": "I clienti di questa unità non la vedono più nel loro portale.",
        "remove_from_unit_header": "Rimuovere «{title}» da questa unità?"
      },
      "deep_link": {
        "show_all": "Mostra tutti i compiti",
        "single": "Sta visualizzando un compito."
      },
      "empty": {
        "filtered_description": "Nessun risultato con i filtri che hai scelto. Cancellali per vedere tutte le attività.",
        "filtered_description_project": "Nessun risultato con i filtri che hai scelto. Cancellali per vedere tutte le attività di questo progetto.",
        "filtered_title": "Nessuna attività corrisponde ai tuoi filtri",
        "none_description": "Crea un'attività e assegnala al tuo team o ai clienti di una o più unità. Compare qui non appena la invii.",
        "none_description_sup": "Crea un'attività e assegnala al tuo team o ai tuoi clienti. Compare qui non appena la invii.",
        "none_title": "Ancora nessuna attività"
      },
      "filters": {
        "phase_none": "Nessuna fase",
        "search": "Cerca attività"
      },
      "form": {
        "category_subtitle": "Scegli come l'assegnatario segna l'attività come completata",
        "category_title": "Come si completa?",
        "description_help": "Visibile a tutti coloro che ricevono questa attività.",
        "description_placeholder": "Aggiungi dettagli o istruzioni",
        "edit_info_assignments": "Responsabili, unità e scadenze li gestisci per responsabile nell'elenco delle attività.",
        "edit_info_assignments_project": "Responsabili e scadenze li gestisci per responsabile nell'elenco delle attività.",
        "edit_info_fields": "Qui modifichi il titolo e la descrizione.",
        "edit_info_fields_phase": "Qui modifichi il titolo, la descrizione e la fase.",
        "heading_create": "Nuova attività",
        "heading_update": "Modifica attività",
        "phase_help_update": "Ogni unità che ha raggiunto la nuova fase, o l'ha già superata, vede subito questa attività. Le unità che non ci sono ancora arrivate la vedono appena ci arrivano.",
        "phase_help_update_project": "Se questo progetto ha raggiunto la nuova fase, o l'ha già superata, i suoi responsabili vedono subito questa attività. Altrimenti la vedono appena il progetto ci arriva.",
        "scope_headline": "{count} attività verrà creata e inviata | {count} attività verranno create e inviate",
        "scope_project": "{assignees} in questo progetto",
        "scope_units": "{units} × {assignees}",
        "title_placeholder": "Cosa bisogna fare?",
        "units_selected": "{selected} di {count} unità selezionata | {selected} di {count} unità selezionate",
        "units_title": "Quali unità"
      },
      "labels": {
        "assignees_count": "{count} responsabile | {count} responsabili",
        "created_by": "Creato da {name} · {date}",
        "created_on": "Creato il {date}",
        "required": "Questo campo è obbligatorio",
        "set_all_assignees": "Imposta per il responsabile | Imposta per tutti i {count} responsabili",
        "still_to_do": "{count} ancora da fare",
        "tasks_count": "{count} attività | {count} attività",
        "units_count": "{count} unità | {count} unità",
        "units_required": "Selezioni almeno un’unità"
      },
      "toasts": {
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "remove_from_unit": "Attività rimossa da questa unità",
        "update": "Attività aggiornata"
      }
    }
  }
}
